import VoletReno from 'assets/img/volet-reno.png';
import VoletTradi from 'assets/img/volet-tradi.png';
import formInputsTypes from 'constants/simulatorData/simulatorConstant';
import VoletTablier from 'assets/img/volet-tablier.png';
import MoteurVolet from 'assets/img/moteur-volet.png';

import VoletRoulant from 'assets/img/volet-roulant.png';
import VoletRoulantMotorise from 'assets/img/Volet-roulant-motorise.png';
import VoletRoulantManuel from 'assets/img/Volet-roulant-manuel.png';

import AxeMotoriseVolet from 'assets/img/kit-motorisation-volet.png';
import AxeManuelVolet from 'assets/img/kit-manuel-volet.png';



import { Moteur } from 'constants/simulatorDataDetails/simulatorConstant';
import TablierVolet from './tablier';
import AxeManuel from './axeManuel';
import AxeMotorise from './axeMotorise';
import CompletManuel from './completManuel';
import completMotorise from './completMotorise';

const voletRoulantProduits = {
	id: 'VR-TI-TR',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Type de Fabrication',
	name: 'typeproduct',
	classGroup: 'SProduit',
	nextStep: false,

	fetchData: (currentFormValue, fnSuccess) => {
		const type = currentFormValue?.values?.typeInstallation?.value
		const options = [
			{
				id: 'VR-TR-TAB',
				label: 'Tablier',
				value: 'Tablier Volet roulant',
				imageUrl: VoletTablier,
				nextStep: TablierVolet,
				description:
					`Fourniture de Tablier Volet roulant ${type} \n` +
					"Tablier fabriqué à partir d'aluminium de haute qualité, injecté avec précision pour garantir une solidité exceptionnelle et une résistance aux intempéries. \n" +
					"Notre tablier en aluminium contribue à une meilleure isolation thermique et phonique, ce qui peut se traduire par des économies d'énergie et un confort accru. \n" +
					'Il répond aux exigences de la norme NF EN 13561. ',
			},
			{
				id: 'VR-TR-AXsE',
				label: 'Moteur',
				value: 'Moteur',
				imageUrl: MoteurVolet,
				nextStep: Moteur(),
				description:
					`Fourniture d’un moteur pour volet roulant ${type}.\n` +
					"Moteur fiable et silencieux assurant une montée et une descente fluides du tablier.\n" +
					"Ce moteur répond aux exigences de la norme NF EN 13659."

			},
			{
				id: 'VR-TR-AXsE',
				label: 'Mécanisme Manuel',
				value: 'Kit Manuel',
				imageUrl: AxeManuelVolet,
				nextStep: AxeManuel,
				description:
					`Remplacement Mécanisme Complet Volet Roulant ${type} à Manivelle.\n` +
					'Composé d’un axe robuste et des éléments de transmission adaptés, garantissant une installation fiable, durable et conforme aux exigences de la norme NF EN 13659.',
				// description:
				// 	`Fourniture d’un kit manuel pour volet roulant ${type}.\n` +
				// 	'Composé d’un axe robuste et des éléments de transmission adaptés, garantissant une installation fiable, durable et conforme aux exigences de la norme NF EN 13659.',
			},

			{
				id: 'VR-TR-AXsE',
				label: 'Kit Motorisation',
				value: 'Kit Motorisation',
				imageUrl: AxeMotoriseVolet,
				nextStep: AxeMotorise,
				// description:
				// 	`Fourniture d’un kit motorissation pour volet roulant ${type}.\n` +
				// 	'Ensemble équipé d’un moteur fiable et silencieux, assurant une ouverture et une fermeture fluides et confortables du volet roulant.\n' +
				// 	'Ce kit est conforme aux exigences de la norme NF EN 13659, garantissant une performance optimale et une installation facile pour un usage quotidien sécurisé et silencieux.',

				description:
					`Fourniture d’un kit motorisation pour volet roulant ${type}.\n` +
					// 'Ensemble équipé d’un moteur fiable et silencieux, assurant une ouverture et une fermeture fluides et confortables du volet roulant.\n' +
					'Ce kit est conforme aux exigences de la norme NF EN 13659.',

			},


			{
				id: 'VR-TR-VRC-MAN',
				label: 'Volet Complet manuel',
				value: 'Volet Roulant Complet Manuel',
				imageUrl: VoletRoulantManuel,
				nextStep: CompletManuel,
				description:
					`Fourniture d’un volet roulant ${type} manuel complet, fabriqué en aluminium de haute qualité injecté avec précision afin de garantir une excellente rigidité, une durabilité accrue et une résistance optimale aux intempéries.\n` +
					`Le volet est équipé d’un axe et d’un système de manœuvre manuelle, assurant une ouverture et une fermeture fluides, fiables et adaptées à un usage quotidien.\n` +
					'Il répond aux exigences de la norme NF EN 13561. ',
			},


			{
				id: 'VR-TR-VRC-MOT',
				label: 'Volet Complet motorisé',
				value: 'Volet Roulant Complet Motorisé',
				imageUrl: VoletRoulantMotorise,
				nextStep: completMotorise,
				description:
					`Fourniture d’un volet roulant ${type} motorisé complet, fabriqué en aluminium de haute qualité injecté avec précision afin de garantir une excellente rigidité, une durabilité accrue et une résistance optimale aux intempéries.\n` +
					`Le volet est équipé d’un moteur électrique fiable et silencieux, permettant une montée et une descente fluides du tablier pour un confort d’utilisation optimal, une sécurité renforcée et un usage quotidien simplifié.\n` +
					'Il répond aux exigences de la norme NF EN 13561. ',
			}




		]
		fnSuccess(options)
	}
};

const voletRoulantRenoType = {
	id: 'VR-TI',
	type: formInputsTypes?.RADIO_INPUT,
	label: "Sélectionner le type d'accès",
	name: 'facile',
	className: 'col-12',
	classGroup: 'SInstallation',
	nextStepData: voletRoulantProduits,
	options: [
		{
			id: 'VR-TR',
			label: 'Accès Facile / PETIT COFFRE',
			value: 'Accès Facile',
			// imageUrl: VoletTradi,
			// nextStep: voletRoulantReno,
		},
		{
			id: 'VR-RN',
			label: 'Accès Difficile / GRAND COFFRE',
			value: 'Accès Difficile',
			// imageUrl: VoletReno,
			// nextStep: voletRoulantReno,
		},
	],
};

const voletRoulant = {
	id: 'VR-TI',
	type: formInputsTypes?.RADIO_INPUT,
	label: "Sélectionner le type d'installation",
	name: 'typeInstallation',
	className: 'col-12',
	classGroup: 'SInstallation',
	nextStep: false,
	options: [
		{
			id: 'VR-TR',
			label: 'Traditionnel',
			value: 'Traditionnel',
			imageUrl: VoletTradi,
			// nextStep: voletRoulantTradi,
			nextStep: voletRoulantProduits,

		},
		{
			id: 'VR-RN',
			label: 'Bloc Baie',
			value: 'Bloc Baie',
			imageUrl: VoletReno,
			// nextStep: voletRoulantBlocBaie,
			nextStep: voletRoulantProduits
		},
		{
			id: 'VR-RN-1',
			label: 'Réno',
			value: 'Réno',
			imageUrl: VoletReno,
			nextStep: voletRoulantProduits,
		},
	],
};

export default voletRoulant;
